var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copyright"},[_vm._v(" ©"+_vm._s(_vm.currentYear)+" ООО «КИОН». Все права защищены "),_c('br'),_c('a',{on:{"click":function($event){return _vm.goTo('Offer')}}},[_vm._v("Пользовательское соглашение")])])
}
var staticRenderFns = []

export { render, staticRenderFns }